import { Centrifuge } from "centrifuge";

import { runtimeConfig } from "@/config/env";
import { useAuthStore } from "@/stores/auth-store";

let client: Centrifuge | null = null;

export function getRealtimeClient() {
  if (client) {
    return client;
  }

  const { session } = useAuthStore.getState();
  client = new Centrifuge(runtimeConfig.centrifugoUrl, {
    token: session?.token,
    getToken: async () => useAuthStore.getState().session?.token ?? "",
  });

  client.connect();
  return client;
}
